import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DivisionLookupComponent } from './division-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [DivisionLookupComponent],
  exports: [DivisionLookupComponent]
})
export class DivisionLookupModule { }
